import { createContext, useContext } from 'react';

/**
 * True inside the blue page band (T-098): Buttons there switch to their on-brand look. Overlay
 * contents (dialogs, sheets, popovers, menus, selects) reset it, because they portal onto the
 * normal surface even when their trigger sits in the band.
 */
export const OnBrandContext = createContext(false);

export function useOnBrand(): boolean {
  return useContext(OnBrandContext);
}

/**
 * Where `PageHeader` renders: the band slot at the top of `<main>` inside the app shell
 * (`HTMLElement`), not mounted yet (`null`), or no shell at all (`undefined`, e.g. unit tests
 * and the `/dev/ui` page), in which case the header renders in place.
 */
export const PageBandSlotContext = createContext<HTMLElement | null | undefined>(undefined);
